// Comic Book Agent Models

export interface CharacterInfo {
  name: string;
  description?: string;
  role?: string;
}

export interface StartComicSessionRequest {
  conceptDescription?: string;
  title?: string;
  genre?: string;
  style?: string;
  initialCharacters?: CharacterInfo[];
  issueCount?: number;
  generateNarrativeArc?: boolean;
}

export interface ComicSessionStartResponse {
  sessionId?: string;
  message?: string;
  title?: string;
  conceptDescription?: string;
  narrativeArc?: string;
  characterCount?: number;
  issueCount?: number;
  success?: boolean;
  errors?: string[] | null;
}

export interface ComicCharacterResponse {
  characterName?: string;
  visualDescription?: string;
  personality?: string;
  backstory?: string;
  abilities?: string;
  relationships?: string;
}

export interface ComicPageResponse {
  pageNumber?: number;
  panels?: ComicPanelInfo[];
}

export interface ComicPanelInfo {
  panelNumber?: number;
  description?: string;
  dialogue?: string;
  narration?: string;
}

export interface ComicScriptResponse {
  script?: string;
  comicTitle?: string;
  issueNumber?: number;
  pageCount?: number;
}

export interface ComicIterateRequest {
  feedback?: string;
  panelRequest?: string;
}

export interface ComicIterateResponse {
  sessionId?: string;
  message?: string;
  pages?: ComicPageResponse[];
  characters?: ComicCharacterResponse[];
  script?: ComicScriptResponse;
}

export interface ComicSession {
  id: string;
  sessionId?: string;
  title: string;
  conceptDescription?: string;
  genre?: string;
  style?: string;
  issueCount?: number;
  characters?: CharacterInfo[];
  narrative?: string;
  script?: string;
  issues?: any[];
  createdAt: Date;
}

export interface ComicSessionStorage {
  sessions: ComicSession[];
  lastUpdated: Date;
}

// Common options for UI
export const COMIC_GENRES = [
  'Superhero',
  'Manga/Anime',
  'Science Fiction',
  'Fantasy',
  'Horror',
  'Mystery/Crime',
  'Slice of Life',
  'Romance',
  'Action/Adventure',
  'Comedy',
  'Historical',
  'Western',
  'War',
  'Noir',
  'Cyberpunk',
  'Post-Apocalyptic'
];

export const COMIC_STYLES = [
  'American Comic Book',
  'Manga (Japanese)',
  'Manhwa (Korean)',
  'European (Bande Dessinée)',
  'Webcomic',
  'Graphic Novel',
  'Underground/Alternative',
  'Cartoon/Humorous',
  'Realistic',
  'Minimalist',
  'Noir/Dark',
  'Colorful/Vibrant'
];